import React, { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { Reveal } from "../components/Reveal";
import { IMG } from "../lib/scenes";

// One Action — the turning point. The Digital Mise en Place.
export const SceneOneAction = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const scale = useTransform(scrollYProgress, [0, 1], [1.08, 1]);

  return (
    <section
      id="one-action"
      data-scene
      ref={ref}
      className="relative px-6 py-16 md:px-12 md:py-28 lg:px-24"
    >
      <div className="mx-auto w-full max-w-[1500px]">
        <Reveal className="mx-auto mb-10 max-w-3xl text-center">
          <span className="font-body text-[11px] uppercase tracking-[0.32em] text-[#EA6A43]">
            The idea
          </span>
          <h2 className="mt-6 font-display text-6xl font-black leading-[0.92] tracking-tighter text-[#1b1a18] sm:text-7xl">
            Do it once. It’s done.
          </h2>
        </Reveal>

        <motion.div
          initial={{ opacity: 0, scale: 0.98 }}
          whileInView={{ opacity: 1, scale: 1 }}
          viewport={{ once: true, margin: "-12%" }}
          transition={{ duration: 0.9, ease: [0.16, 1, 0.3, 1] }}
          className="relative mx-auto overflow-hidden rounded-2xl"
        >
          <motion.img
            src={IMG.oneAction}
            alt="A chef's hands, working with care on the board"
            style={{ scale }}
            className="aspect-[21/9] w-full object-cover"
            loading="lazy"
          />
        </motion.div>

        <Reveal delay={0.1} className="mx-auto mt-10 max-w-2xl text-center">
          <p className="font-display text-3xl font-bold tracking-tight text-[#EA6A43] sm:text-4xl">
            The Digital Mise en Place.
          </p>
        </Reveal>
      </div>
    </section>
  );
};
